import ActivityEditTabs from './ActivityEditTabs';

export default ActivityEditTabs;
